export const uk = {
    accept: 'Застосувати',
    back: 'Назад',
    rest: 'И еще {count}, продолжайте печатать'
};
